import { useModal, BottomSheet } from "@business-finland/wif-ui-lib";
import { PageHeader } from "@business-finland/wif-ui-lib/dist/PageHeader";
import dynamic from "next/dynamic";

import useEmployerSite from "../../../../contexts/EmployerSiteContext";
import { getCompanyFormId } from "../helpers";

const HtmlParser = dynamic(() => import("../../../../components/HtmlParser"));

export type CompanyFormInstructions = { heading: string; content: string };

export interface ICompanyFormHeaderProps {
  heading: string;
  leadText: string;
  instructions?: CompanyFormInstructions;
}

export default function CompanyFormHeader({
  heading,
  leadText,
  instructions,
}: ICompanyFormHeaderProps) {
  const { isEmployerSite } = useEmployerSite();
  const { isModalOpen, openModal, closeModal } = useModal();

  const leadTextElement = instructions ? (
    <div onClick={openModal} style={{ cursor: "pointer" }}>
      <HtmlParser html={leadText} />
    </div>
  ) : (
    <HtmlParser html={leadText} />
  );

  return (
    <>
      <PageHeader
        id={getCompanyFormId("header")}
        heading={heading}
        leadText={leadTextElement}
        backgroundColor={isEmployerSite ? "blue" : "lightBlue"}
      />
      {instructions ? (
        <BottomSheet
          isVisible={isModalOpen}
          closeModal={closeModal}
          heading={instructions.heading}
        >
          <HtmlParser html={instructions.content} />
        </BottomSheet>
      ) : null}
    </>
  );
}
